import { useQueryClient } from '@tanstack/react-query';

import { createIntentKey, useCatalogRemovalMutation } from '../../api/index.js';
import { useWorkspace } from '../../app/runtime.js';

export function useTrackRemoval(onRemoved: (trackIds: readonly string[]) => void) {
  const { connection, library } = useWorkspace();
  const queryClient = useQueryClient();
  const mutation = useCatalogRemovalMutation();

  const removeTracks = async (trackIds: readonly string[]) => {
    mutation.reset();
    await mutation.mutateAsync({
      libraryId: library.id,
      connectionId: connection.id,
      trackIds,
      idempotencyKey: createIntentKey(),
    });
    onRemoved(trackIds);
    void Promise.all([
      queryClient.invalidateQueries({ queryKey: ['catalog'] }),
      queryClient.invalidateQueries({ queryKey: ['project-cards'] }),
    ]);
  };

  return {
    isPending: mutation.isPending,
    removeTracks,
  };
}
